import React from 'react';
import { Modal } from './Modal';
import { PillButton } from './PillButton';
import { Row } from './Row';
import { Stack } from './Stack';
import { Text } from './Text';

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    message: React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    confirmText?: string;
    cancelText?: string;
}

export function ConfirmDialog({
    open,
    title,
    message,
    onClose,
    onConfirm,
    confirmText = 'OK',
    cancelText = 'Cancel',
}: ConfirmDialogProps) {
    if (!open) return null;

    return (
        <Modal title={title} onClose={onClose} width={440}>
            <Stack gap="md">
                <Text>{message}</Text>
                <Row justify="end" gap="sm">
                    {onConfirm && (
                        <PillButton variant="secondary" onClick={onClose}>
                            {cancelText}
                        </PillButton>
                    )}
                    <PillButton onClick={onConfirm ?? onClose}>{confirmText}</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
